export default "__VITE_ASSET__9d6e6924__"